import React, { useState, useEffect } from "react";
import ClausesSearch from "./clausesSearch";
import { useStateValue } from "../../context/store";
import CreateClauses from "./create-clauses/createClausesContracts";
import DetailTable from "./tableClauses";
import { headers } from "./dataClauses";
import { Typography, TablePagination } from "@material-ui/core";
import Search from "../../images/icons/search.svg";
import { styles } from "../styles";
import { getClauses } from "../../actions/clauses-actions";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import { permissionsConstans } from "../../constansPermissions";
import { withRouter } from "react-router";
import utils from "../../utils/utils";

const Index = (props) => {
  const classes = styles();
  const [{ filterClauses }, dispatch] = useStateValue();
  const [resetPetition, setResetPetition] = useState(false);
  const [permissionsClause, setPermissionsClause] = useState([]);
  const [data, setData] = useState({
    name: null,
  });

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "creationDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
  };

  const resetRequest = () => setResetPetition(!resetPetition);

  const getReqs = async () => {
    const response = await getClauses(
      {
        name: data.name === "" ? null : data.name,
        initDate: data.initDate === "" ? null : data.initDate,
        endDate: data.endDate === "" ? null : data.endDate,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },

      dispatch
    );
    if (response?.data?.content?.length > 0) {
      const data = response?.data;
      setPaginadorResponse({
        data: data?.content,
        totalRows: data?.totalElements,
        pageSize: data?.size,
        pageNumber: data?.number,
      });
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.status !== 403
    ) {
      setMessage({
        description: response?.data?.detail,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  };

  if (
    filterClauses &&
    filterClauses?.isFilter &&
    data !== filterClauses.filter
  ) {
    var newfilter = filterClauses.filter;
    data.name = newfilter.name;
    data.initDate = newfilter.initDate;
    data.endDate = newfilter.endDate;
    paginadorRequest.page = 0;
    getReqs();
    dispatch({
      type: "SET_FILTER_CLAUSE",
      isFilter: false,
    });
  }

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  useEffect(() => {
    const responsePermission = utils.validationPermissions("FOR_CLA_CON");
    setPermissionsClause(responsePermission);
  }, []);

  const validationPermissionPathCreate = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "FOR_CLA_CON");

    if (
      module?.functionalities?.some(
        (x) => x === permissionsConstans.FOR_CLA_CON_CREAR
      )
    ) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    getReqs();
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Gestionar cláusulas",
      breadCrumbSubText: "Gestionar cláusulas",
      index: 10,
      isButtonCreate: validationPermissionPathCreate(),
    });
  }, [resetPetition, paginadorRequest]);

  const validationPermissionSearch = () => {
    if (
      permissionsClause?.functionalities?.some(
        (x) => x === permissionsConstans.FOR_CLA_CON_CONSULTAR
      )
    ) {
      return <ClausesSearch />;
    }
  };

  return (
    <>
      <ModalConfirmBase
        open={message.open}
        description={message.description}
        handleClickOut={message.handleClickOut}
        handleClick={message.handleClick}
        oneButtons={message.oneButtons}
        textButtonSubmit={message.buttonOneText}
        type={message.type}
      />
      {validationPermissionSearch()}
      <CreateClauses
        setMessage={setMessage}
        message={message}
        reset={resetRequest}
      />

      {paginadorResponse?.data?.map((row, index) => (
        <>
          <DetailTable
            key={index}
            headers={headers}
            data={row}
            setMessage={setMessage}
            message={message}
            reset={resetRequest}
          />
        </>
      ))}

      {paginadorResponse?.totalRows !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={paginadorResponse.totalRows}
          rowsPerPage={paginadorRequest.size}
          page={paginadorRequest.page}
          labelRowsPerPage="Registros por página"
          onChangePage={changePage}
          onChangeRowsPerPage={changeAmountOfRecords}
        />
      ) : (
        <React.Fragment>
          <div className={classes.messageSearch}>
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado
            </Typography>
          </div>
        </React.Fragment>
      )}
    </>
  );
};

export default withRouter(Index);
